import { connect } from 'react-redux';

import BatterySelect from './battery';
import { addBattery, removeBattery } from '../../../reducers/cart';

export default connect((state) => state, { addBattery, removeBattery })(
  BatterySelect
);
